import React from "react";
import { Gauge } from "lucide-react";
import { COLOR } from "./pillars/_cards";

const ratedPeakKw = (vehicle) => {
  const model = vehicle?.model || "Model 3";
  const year = vehicle?.year || 2021;
  const lfp = /rwd|standard/i.test(vehicle?.trim || "");
  if (model === "Cybertruck") return 250;
  if (model === "Model 3" || model === "Model Y") return lfp ? 170 : 250;
  return year >= 2021 ? 250 : 150; // S/X refresh vs legacy
};

/** Fast-Charge Fitness — estimated peak Supercharging speed vs when new.
 *  Packs lose peak kW as they age, not just range. */
export const FastChargeFitnessCard = ({ vehicle }) => {
  const soh = vehicle?.sohCurrent ?? null;
  if (soh == null) return null;

  const rated = ratedPeakKw(vehicle);
  const estNow = Math.round(rated * Math.pow(soh / 100, 1.6));
  const pct = Math.round((estNow / rated) * 100);
  const barColor = pct >= 90 ? COLOR.green : pct >= 78 ? COLOR.amber : COLOR.red;

  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: "rgba(255,255,255,0.08)", background: "rgba(255,255,255,0.02)" }}
      data-testid="fastcharge-fitness-card"
    >
      <div className="flex items-center gap-3 mb-2">
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center border shrink-0"
          style={{ background: `${COLOR.cyan}18`, borderColor: `${COLOR.cyan}55` }}
        >
          <Gauge className="w-4 h-4" style={{ color: COLOR.cyan }} strokeWidth={2.4} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-zinc-500">
            Fast-charge fitness
          </div>
          <div className="text-sm text-white font-semibold leading-snug">
            Estimated peak {vehicle?.brand === "ford" ? "DC fast-charging" : "Supercharging"} speed
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-display text-2xl text-white font-semibold leading-none" data-testid="fastcharge-est-kw">
            {estNow}<span className="font-mono text-[10px] text-zinc-400">kW</span>
          </div>
          <div className="font-mono text-[9px] uppercase tracking-wider text-zinc-500 mt-1">
            of {rated} kW new
          </div>
        </div>
      </div>

      <div className="h-1.5 rounded-full overflow-hidden bg-white/5">
        <div
          className="h-full rounded-full"
          style={{
            width: `${pct}%`,
            background: `linear-gradient(90deg, ${barColor}88, ${barColor})`,
            boxShadow: `0 0 12px ${barColor}55`,
          }}
        />
      </div>

      <p className="font-mono text-[10px] text-zinc-400 leading-relaxed mt-2" data-testid="fastcharge-tip">
        {pct >= 90
          ? "Peak speed is holding near factory. Precondition en route to stay at the top of the curve."
          : `Peak kW fades with pack age — precondition before ${vehicle?.brand === "ford" ? "DC fast-charging" : "Supercharging"} and arrive below 20% SoC to hit your best speed.`}
        {" "}Estimated from SoH · updates as your pack ages.
      </p>
    </div>
  );
};
